import { useQuery } from '@tanstack/react-query';

import map from 'lodash/map';

import { API } from 'src/reactQuery/Api';
import { QUERY_KEYS } from 'src/reactQuery/QueryKeys';
import { getRequest } from 'src/utils/request';

import type { RequestDataArray } from 'src/types/requestData';

const mapProjectType = (
  projectType: UCM.ProjectTypeRawType,
  id: string,
): UCM.ProjectTypeType => ({
  value: id,
  label: projectType.name,
});

const getProjectTypes = async () => {
  const {
    data: { data },
  } = await getRequest<RequestDataArray<UCM.LanguageLevelOptionRawType>>(
    API.GET.getProjectTypes,
  );

  return map(data, ({ attributes, id }) => mapProjectType(attributes, id));
};

export const useGetProjectTypes = (
  config: { enabled?: boolean } = { enabled: true },
) => {
  return useQuery({
    queryKey: [QUERY_KEYS.PROJECT_TYPES],
    queryFn: getProjectTypes,
    ...config,
  });
};
